<!-----basic design ------>
<div *ngIf="!showCheckoutIframe">
  <div>
    <h1 class="headText">BLVD ChatBot</h1></div>
  <div class="main-chat-container">
    <div class="chat-container" >
      <div #messagesContainer class="messages">
        <div *ngFor="let msg of promptDeafaultMsg" [ngClass]="msg.role">
          
          <img *ngIf="!isWelcomeOptionHide" class="avatar" src="assets/user.svg" alt="Agent" />
          <div *ngIf="!isWelcomeOptionHide" class="message-text" [innerHTML]="getContent(msg.content)"></div>

          <div class="options" *ngIf="msg.options?.length && !isWelcomeOptionHide">
            <button
              *ngFor="let opt of msg.options"
              (click)="onOptionSelect(opt, msg)"
              class="option-btn">
              {{ opt.label }}
            </button>
          </div>

          
        </div>
        <div *ngFor="let msg of chatMessages" [ngClass]="msg.role">
          
          <img *ngIf="msg.role=='assistant' && msg?.button?.type!='SHOW_PAY_BUTTON'" class="avatar" src="assets/user.svg" alt="Agent" />
          <div *ngIf="msg?.button?.type!='SHOW_PAY_BUTTON'" class="message-text" [innerHTML]="getContent(msg.content)"></div>

          <div class="text-center mt-3" *ngIf="msg?.button?.type === 'SHOW_PAY_BUTTON'">

            <a href="#" class="checkout-link" (click)="goToCheckout(msg?.button?.checkoutUrl)">
              <span class="hand">👉</span>
              <span class="text">Click Here</span>
            </a> To Payment
          </div>
          
        </div>
        
      <div *ngIf="isLoading" class="agent loading">
        <div class="message-text">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </div>
      </div>
    
      <div class="fixedFooter">
        <div class="chat-input">
            <input
              [(ngModel)]="userInput"
              placeholder="Ask a question"
              (keyup.enter)="sendMessage()"
            />
            <button (click)="sendMessage()">➤</button>

        </div>
        <div class="footerDiv">
          <footer class="chat-footer">
            Verified. Powered by Opensource Technologies
          </footer>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="showCheckoutIframe" class="iframe-wrapper">
  <iframe
    id="checkoutFrame"
    [src]="safeCheckoutUrl"
    width="100%"
    height="650"
    frameborder="0"
    (load)="onIframeLoad()"
  ></iframe>
</div>

  